import { SERVICE } from './constants'

export const SET_ENERGIES = `${SERVICE}/SET_ENERGIES`
export const CLEAR_ENERGIES = `${SERVICE}/CLEAR_ENERGIES`
